module.exports = __webpack_public_path__ + "assets/videos/banner-video-poster-desktop.jpg?v=6a092cf3";